import {
  Server,
  Code,
  Brain,
  Sparkles, type LucideIcon } from 'lucide-react';

export interface LLMModelConfig {
  id: string;
  name: string;
  provider: string;
  model: string;
  icon: LucideIcon;
  color: string;
  desc: string;
  tags: string[];
  context: string;
  requiresKey: boolean;
  keyField?: string;
  keyLabel?: string;
}

export const LLM_MODELS: LLMModelConfig[] = [
  {
    id: 'ollama',
    name: 'Ollama 本地',
    provider: 'ollama',
    model: 'qwen3.5:0.8b',
    icon: Server,
    color: 'text-success',
    desc: '本地轻量小模型，约 1GB',
    tags: ['本地', '低延迟', '中文'],
    context: '32K',
    requiresKey: false,
  },
  {
    id: 'opencode-gpt-5-6-sol',
    name: 'GPT 5.6 Sol',
    provider: 'opencode',
    model: 'opencode/gpt-5.6-sol',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.6 Sol',
    tags: ["推理"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-6-terra',
    name: 'GPT 5.6 Terra',
    provider: 'opencode',
    model: 'opencode/gpt-5.6-terra',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.6 Terra',
    tags: [],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-6-luna',
    name: 'GPT 5.6 Luna',
    provider: 'opencode',
    model: 'opencode/gpt-5.6-luna',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.6 Luna',
    tags: [],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-5',
    name: 'GPT 5.5',
    provider: 'opencode',
    model: 'opencode/gpt-5.5',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.5',
    tags: [],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-5-pro',
    name: 'GPT 5.5 Pro',
    provider: 'opencode',
    model: 'opencode/gpt-5.5-pro',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.5 Pro',
    tags: ["推理"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-4',
    name: 'GPT 5.4',
    provider: 'opencode',
    model: 'opencode/gpt-5.4',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.4',
    tags: [],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-4-pro',
    name: 'GPT 5.4 Pro',
    provider: 'opencode',
    model: 'opencode/gpt-5.4-pro',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.4 Pro',
    tags: ["推理"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-4-mini',
    name: 'GPT 5.4 Mini',
    provider: 'opencode',
    model: 'opencode/gpt-5.4-mini',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.4 Mini',
    tags: ["快速"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-4-nano',
    name: 'GPT 5.4 Nano',
    provider: 'opencode',
    model: 'opencode/gpt-5.4-nano',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.4 Nano',
    tags: ["快速"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-3-codex',
    name: 'GPT 5.3 Codex',
    provider: 'opencode',
    model: 'opencode/gpt-5.3-codex',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.3 Codex',
    tags: ["代码"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-3-codex-spark',
    name: 'GPT 5.3 Codex Spark',
    provider: 'opencode',
    model: 'opencode/gpt-5.3-codex-spark',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.3 Codex Spark',
    tags: ["代码"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-2',
    name: 'GPT 5.2',
    provider: 'opencode',
    model: 'opencode/gpt-5.2',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.2',
    tags: [],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-2-codex',
    name: 'GPT 5.2 Codex',
    provider: 'opencode',
    model: 'opencode/gpt-5.2-codex',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.2 Codex',
    tags: ["代码"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-1',
    name: 'GPT 5.1',
    provider: 'opencode',
    model: 'opencode/gpt-5.1',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.1',
    tags: [],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-1-codex',
    name: 'GPT 5.1 Codex',
    provider: 'opencode',
    model: 'opencode/gpt-5.1-codex',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.1 Codex',
    tags: ["代码"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-1-codex-max',
    name: 'GPT 5.1 Codex Max',
    provider: 'opencode',
    model: 'opencode/gpt-5.1-codex-max',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.1 Codex Max',
    tags: ["代码", "推理"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-1-codex-mini',
    name: 'GPT 5.1 Codex Mini',
    provider: 'opencode',
    model: 'opencode/gpt-5.1-codex-mini',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5.1 Codex Mini',
    tags: ["代码", "快速"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5',
    name: 'GPT 5',
    provider: 'opencode',
    model: 'opencode/gpt-5',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5',
    tags: [],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-codex',
    name: 'GPT 5 Codex',
    provider: 'opencode',
    model: 'opencode/gpt-5-codex',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5 Codex',
    tags: ["代码"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gpt-5-nano',
    name: 'GPT 5 Nano',
    provider: 'opencode',
    model: 'opencode/gpt-5-nano',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GPT 5 Nano',
    tags: ["快速"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-claude-fable-5',
    name: 'Claude Fable 5',
    provider: 'opencode',
    model: 'opencode/claude-fable-5',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Claude Fable 5',
    tags: ["推理"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-claude-opus-4-8',
    name: 'Claude Opus 4.8',
    provider: 'opencode',
    model: 'opencode/claude-opus-4-8',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Claude Opus 4.8',
    tags: ["推理"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-claude-opus-4-7',
    name: 'Claude Opus 4.7',
    provider: 'opencode',
    model: 'opencode/claude-opus-4-7',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Claude Opus 4.7',
    tags: ["推理"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-claude-opus-4-6',
    name: 'Claude Opus 4.6',
    provider: 'opencode',
    model: 'opencode/claude-opus-4-6',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Claude Opus 4.6',
    tags: ["推理"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-claude-opus-4-5',
    name: 'Claude Opus 4.5',
    provider: 'opencode',
    model: 'opencode/claude-opus-4-5',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Claude Opus 4.5',
    tags: ["推理"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-claude-sonnet-5',
    name: 'Claude Sonnet 5',
    provider: 'opencode',
    model: 'opencode/claude-sonnet-5',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Claude Sonnet 5',
    tags: [],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-claude-sonnet-4-6',
    name: 'Claude Sonnet 4.6',
    provider: 'opencode',
    model: 'opencode/claude-sonnet-4-6',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Claude Sonnet 4.6',
    tags: [],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-claude-sonnet-4-5',
    name: 'Claude Sonnet 4.5',
    provider: 'opencode',
    model: 'opencode/claude-sonnet-4-5',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Claude Sonnet 4.5',
    tags: [],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-claude-haiku-4-5',
    name: 'Claude Haiku 4.5',
    provider: 'opencode',
    model: 'opencode/claude-haiku-4-5',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Claude Haiku 4.5',
    tags: [],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gemini-3-5-flash',
    name: 'Gemini 3.5 Flash',
    provider: 'opencode',
    model: 'opencode/gemini-3.5-flash',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Gemini 3.5 Flash',
    tags: ["快速"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gemini-3-1-pro',
    name: 'Gemini 3.1 Pro',
    provider: 'opencode',
    model: 'opencode/gemini-3.1-pro',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Gemini 3.1 Pro',
    tags: ["快速", "推理"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-gemini-3-flash',
    name: 'Gemini 3 Flash',
    provider: 'opencode',
    model: 'opencode/gemini-3-flash',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Gemini 3 Flash',
    tags: ["快速"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-qwen3-7-max',
    name: 'Qwen3.7 Max',
    provider: 'opencode',
    model: 'opencode/qwen3.7-max',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Qwen3.7 Max',
    tags: ["中文", "推理"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-qwen3-7-plus',
    name: 'Qwen3.7 Plus',
    provider: 'opencode',
    model: 'opencode/qwen3.7-plus',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Qwen3.7 Plus',
    tags: ["中文"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-qwen3-6-plus',
    name: 'Qwen3.6 Plus',
    provider: 'opencode',
    model: 'opencode/qwen3.6-plus',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Qwen3.6 Plus',
    tags: ["中文"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-qwen3-5-plus',
    name: 'Qwen3.5 Plus',
    provider: 'opencode',
    model: 'opencode/qwen3.5-plus',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Qwen3.5 Plus',
    tags: ["中文"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-minimax-m3',
    name: 'MiniMax M3',
    provider: 'opencode',
    model: 'opencode/minimax-m3',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'MiniMax M3',
    tags: ["快速", "推理"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-minimax-m2-7',
    name: 'MiniMax M2.7',
    provider: 'opencode',
    model: 'opencode/minimax-m2.7',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'MiniMax M2.7',
    tags: ["快速", "推理"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-minimax-m2-5',
    name: 'MiniMax M2.5',
    provider: 'opencode',
    model: 'opencode/minimax-m2.5',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'MiniMax M2.5',
    tags: ["快速", "推理"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-glm-5-2',
    name: 'GLM 5.2',
    provider: 'opencode',
    model: 'opencode/glm-5.2',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GLM 5.2',
    tags: ["中文"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-glm-5-1',
    name: 'GLM 5.1',
    provider: 'opencode',
    model: 'opencode/glm-5.1',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GLM 5.1',
    tags: ["中文"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-glm-5',
    name: 'GLM 5',
    provider: 'opencode',
    model: 'opencode/glm-5',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'GLM 5',
    tags: ["中文"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-grok-4-5',
    name: 'Grok 4.5',
    provider: 'opencode',
    model: 'opencode/grok-4.5',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Grok 4.5',
    tags: [],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-grok-build-0-1',
    name: 'Grok Build 0.1',
    provider: 'opencode',
    model: 'opencode/grok-build-0.1',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Grok Build 0.1',
    tags: [],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-big-pickle',
    name: 'Big Pickle',
    provider: 'opencode',
    model: 'opencode/big-pickle',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Big Pickle',
    tags: [],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-mimo-v2-5-free',
    name: 'MiMo-V2.5 Free',
    provider: 'opencode',
    model: 'opencode/mimo-v2.5-free',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'MiMo-V2.5 Free',
    tags: ["快速"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-north-mini-code-free',
    name: 'North Mini Code Free',
    provider: 'opencode',
    model: 'opencode/north-mini-code-free',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'North Mini Code Free',
    tags: ["代码", "快速"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'opencode-nemotron-3-ultra-free',
    name: 'Nemotron 3 Ultra Free',
    provider: 'opencode',
    model: 'opencode/nemotron-3-ultra-free',
    icon: Brain,
    color: 'text-network-primary',
    desc: 'Nemotron 3 Ultra Free',
    tags: ["快速"],
    context: '128K',
    requiresKey: true,
    keyField: 'opencode_api_key',
    keyLabel: 'API Key',
  },
  {
    id: 'kimi-k2-7-code',
    name: 'Kimi K2.7 Code',
    provider: 'kimi',
    model: 'kimi-k2-7-code',
    icon: Code,
    color: 'text-fusion-primary',
    desc: 'Kimi K2.7 Code via kimi',
    tags: ["代码", "中文", "256K上下文"],
    context: '256K',
    requiresKey: true,
    keyField: 'kimi_api_key',
    keyLabel: 'Kimi API Key',
  },
  {
    id: 'kimi-k2-6',
    name: 'Kimi K2.6',
    provider: 'kimi',
    model: 'kimi-k2-6',
    icon: Code,
    color: 'text-fusion-primary',
    desc: 'Kimi K2.6 via kimi',
    tags: ["中文", "256K上下文"],
    context: '256K',
    requiresKey: true,
    keyField: 'kimi_api_key',
    keyLabel: 'Kimi API Key',
  },
  {
    id: 'kimi-k2-5',
    name: 'Kimi K2.5',
    provider: 'kimi',
    model: 'kimi-k2-5',
    icon: Code,
    color: 'text-fusion-primary',
    desc: 'Kimi K2.5 via kimi',
    tags: ["中文", "256K上下文"],
    context: '256K',
    requiresKey: true,
    keyField: 'kimi_api_key',
    keyLabel: 'Kimi API Key',
  },
  {
    id: 'deepseek-v4-pro',
    name: 'DeepSeek V4 Pro',
    provider: 'deepseek',
    model: 'deepseek-v4-pro',
    icon: Sparkles,
    color: 'text-rose-400',
    desc: 'DeepSeek V4 Pro via deepseek',
    tags: ["推理"],
    context: '128K',
    requiresKey: true,
    keyField: 'deepseek_api_key',
    keyLabel: 'DeepSeek API Key',
  },
  {
    id: 'deepseek-v4-flash',
    name: 'DeepSeek V4 Flash',
    provider: 'deepseek',
    model: 'deepseek-v4-flash',
    icon: Sparkles,
    color: 'text-rose-400',
    desc: 'DeepSeek V4 Flash via deepseek',
    tags: ["快速"],
    context: '128K',
    requiresKey: true,
    keyField: 'deepseek_api_key',
    keyLabel: 'DeepSeek API Key',
  },
];

export const LLM_MODEL_MAP: Record<string, LLMModelConfig> = Object.fromEntries(
  LLM_MODELS.map((m) => [m.id, m])
);

export function getModelByProviderModel(provider: string, model: string): LLMModelConfig | undefined {
  return LLM_MODELS.find(
    (m) => m.provider === provider.toLowerCase() && m.model === model
  );
}

/**
 * 统一 ollama 模型名为 ollama 原始「名:标签」形（qwen3.5:0.8b）。
 * 同一模型历史上有三种写法：冒号形（provider_model_id / ModelConfig model_id）、
 * 短横形（qwen3.5-0.8b，由选择器 id ollama-qwen3.5-0.8b 剥前缀得来）、
 * 目录 id 形（ollama-qwen3.5-0.8b）。store 只存冒号形，各选择点的精确映射
 * （getModelByProviderModel）与防乒乓守卫才有统一比较基准。
 */
export function normalizeOllamaModelName(model: string): string {
  let m = model;
  if (m.startsWith('ollama-')) m = m.slice('ollama-'.length);
  if (m.includes(':')) return m;
  // 短横形只把「名-标签」之间的那个短横转回冒号：标签段以数字开头（0.8b / 135m / 7b），
  // 名字段里的短横（nomic-embed-text、phi4-mini 这类无标签名）不动
  const idx = m.search(/-(?=[0-9][A-Za-z0-9.]*$)/);
  if (idx > 0) return `${m.slice(0, idx)}:${m.slice(idx + 1)}`;
  return m;
}

export function getModelIdByProviderModel(provider: string, model: string): string {
  // 全局控制台选中的平台模型（云端按量）→ 选择器 id 为 platform:{model}
  if (provider.toLowerCase() === 'platform') return `platform:${model}`;
  const exact = getModelByProviderModel(provider, model);
  if (exact) return exact.id;

  // Fallback: match by provider only
  const byProvider = LLM_MODELS.find((m) => m.provider === provider.toLowerCase());
  if (byProvider) return byProvider.id;

  return 'ollama';
}

/** Map a frontend selector id to the backend `preferred_model` identifier. */
export function getBackendModelId(selectorId: string, ollamaModel: string): string {
  if (selectorId === 'ollama') {
    const m = ollamaModel || 'qwen3.5:0.8b';
    if (m === 'qwen3.5:0.8b') return 'ollama-qwen3.5-0.8b';
    // 08-24 前存量本地设置可能还存着旧型号，后端 ModelConfig 保留了对应条目可解析
    if (m === 'qwen2.5:0.5b') return 'ollama-qwen2.5-0.5b';
    if (m === 'smollm2:135m') return 'ollama-smollm2';
    return `ollama-${m}`;
  }
  if (selectorId === 'ollama-smollm2') {
    return 'ollama-smollm2';
  }
  // For cloud models, the selector id matches the backend ModelConfig key.
  return selectorId;
}
